import React, { HTMLInputTypeAttribute } from 'react'

import { InputNumber as AntInputNumber } from 'antd'

import './DataEntryStyles.less'

interface InputNumberProps {
  defaultValue?: number
  autoFocus?: boolean
  disabled?: boolean
  min?: number
  max?: number
  prefix?: string
  suffix?: string
  precision?: number
  decimalSeparator?: string
  step?: number | string
  onPressEnter?: React.KeyboardEventHandler<HTMLInputElement>
  size?: 'large' | 'small'
  onChange?: (value: string | number | undefined) => void
  placeholder?: string
  formatter?: (value: number | string | undefined) => string
  parser?: (displayValue: string | undefined) => number | string
  className?: string
  id?: string
  addonBefore?: React.ReactNode
  addonAfter?: React.ReactNode
  type?: HTMLInputTypeAttribute | undefined
}

const InputNumber: React.FC<InputNumberProps> = (props) => {
  return <AntInputNumber {...props} />
}

export default InputNumber
